<template lang="pug">
.input-with-icon-slot
  textarea(
    v-if="type === 'textarea'"
    :placeholder='placeholder'
    :rows="rows"
    :value='value'
    @input='$emit("input", $event.target.value)'
    :style=`inputStyle`
    :disabled='disabled'
    :autocomplete='autocomplete'

    :class='{"required" : required && !value}'
  )
  input.input-large(
    v-else
    :placeholder='placeholder'
    :value='value'
    @input='$emit("input", $event.target.value)'
    :style=`inputStyle`
    :type='type'
    :disabled='disabled'

    :autocomplete='autocomplete'
    :class='{"required" : required && !value}'
  )
  .icon-slot(
    :class='{"required" : required && !value}'
  )
    slot
</template>

<script>
export default {
  props: {
    value: {
      default: '',
    },
    type: {
      default: 'text',
    },
    placeholder: {
      default: 'ระบุ',
    },
    width: {
      default: '250px',
    },
    rows: {
      default: 3,
    },
    disabled: {
      default: false,
    },
    autocomplete: {
      default: '',
    },

    required: {
      default: false,
    },
  },
  computed: {
    inputStyle() {
      return `width: ${this.width}`;
    },
  },
};
</script>

<style lang="scss">
.input-with-icon-slot {
  position: relative;
  .icon-slot {
    // height: 100%;
    width: 45px;
    padding: 0 8px;

    display: flex;
    align-items: center;

    position: absolute;
    left: 0;
    top: 0;

    font-size: 21px;
    // color: #1F93CA;
    color: #B5B5B7;

    transform: translateY(50%);

    &.required {
      color: red;
    }
  }
  input.input-large {
    padding-left: 45px;
  }
  textarea {
    padding-left: 45px;
    border: none;
    border-bottom: 1px solid #cfdada;
  }
}
</style>
